import React, { Fragment, useMemo } from 'react';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
import cn from 'classnames';

import Button from 'chameleon/ui-stack/ui/base/button';
import PopOver from 'chameleon/ui-stack/ui/base/popover';

import ProgressPopoverContent from './ProgressPopoverContent';
import PDFStatus from './PDFStatus';
import { resourceTypes } from 'chameleon/legacy/src/components/TeacherOrganize/utils/constants';

const StatusText = ({ children, icon }) => (
  <span className={cn('align-middle mb-0 text-12', 'text-gray-800')}>
    {icon}
    <span className={cn({ 'ml-1': icon })}>{children}</span>
  </span>
);

const SummaryRowStatus = (props) => {
  const { assessment = {}, hasAssignedPopoverFF, subjectInitId } = props;
  const { type, is_assigned_in_subject: isAssigned } = assessment || {};
  const isVideo = type === 'video';
  const hasPopover = type !== resourceTypes.pdf;
  const isPDF = type === resourceTypes.pdf;

  if (isPDF) {
    const {
      visibility_to_students: visibilityToStudents,
      shared_with: sharedWith,
    } = assessment || {};
    return (
      <PDFStatus
        scope={[
          'units',
          `unit-${assessment.unit_id}`,
          'resources',
          `resource-${assessment.id}-subject-${subjectInitId}`,
        ]}
        visibilityToStudents={visibilityToStudents}
        sharedWith={sharedWith}
      />
    );
  }

  const hasAssignments = assessment.assignments.length > 0;

  const WrapperClass = isVideo ? Fragment : 'span';
  // Only enable assginm popover for Student Practice
  const TriggerWrapper = useMemo(
    () => (
      <WrapperClass>
        {isAssigned &&
          (hasAssignedPopoverFF && hasAssignments && hasPopover ? (
            <Button isLink isNaked>
              Assigned
            </Button>
          ) : (
            <StatusText>Assigned</StatusText>
          ))}
        {!isAssigned && <StatusText>Unassigned</StatusText>}
      </WrapperClass>
    ),
    [isAssigned],
  );

  return (
    <PopOver
      isNarrow
      closeButtonSize="small"
      trigger={TriggerWrapper}
      disabled={
        !hasAssignedPopoverFF || !(isAssigned && hasAssignments && hasPopover)
      }
    >
      {hasAssignments && hasPopover && <ProgressPopoverContent {...props} />}
    </PopOver>
  );
};

SummaryRowStatus.propTypes = {
  isVideo: PropTypes.bool,
};

SummaryRowStatus.defaultProps = {
  isVideo: false,
};

const mapStateToProps = ({
  featureFlag: { assigned_popover: hasAssignedPopoverFF },
}) => ({
  hasAssignedPopoverFF,
});

export default connect(mapStateToProps)(SummaryRowStatus);
